import { format, isValid, parseISO } from 'date-fns';

export type InvoicingFilters = {
  ownerId: string;
  employerId: string;
  insurerId: string;
  productId: string;
  dateFrom: string;
  dateTo: string;
  skipZeroResults: boolean;
};

export const INITIAL_FILTERS: InvoicingFilters = {
  ownerId: '',
  employerId: '',
  insurerId: '',
  productId: '',
  dateFrom: '',
  dateTo: '',
  skipZeroResults: true,
};

const DATE_FORMAT = 'yyyy-MM-dd';

export const parseDateString = (value: string): Date | null => {
  if (!value) return null;
  const parsed = parseISO(value);
  return isValid(parsed) ? parsed : null;
};

export const formatDateValue = (date: Date | null): string => (date && isValid(date) ? format(date, DATE_FORMAT) : '');

const DEFAULT_FILENAME = 'usage-invoicing.csv';

export const extractFilename = (contentDisposition?: string | null): string | null => {
  if (!contentDisposition) return null;
  const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
};

export const downloadCsvBlob = (data: BlobPart, contentDisposition?: string | null): void => {
  const url = window.URL.createObjectURL(new Blob([data], { type: 'text/csv;charset=utf-8;' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', extractFilename(contentDisposition) || DEFAULT_FILENAME);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
